import { cashIncomeApi } from "../../api";

const CashIncomeService = {

  /**
   * 💰 Registrar ingreso de efectivo
   * POST /api/cash/incomes
   */
  income: async (data: any) => {

    const response = await cashIncomeApi.add(data);

    return response.data;

  }

};

export default CashIncomeService;